import React, { useMemo, useState, useEffect } from 'react';
import StickyTitle from '../components/StickyTitle.js';
import { MaterialReactTable } from 'material-react-table';
import { Box, Button, IconButton } from '@mui/material';
import axios from 'axios';
import { CSVLink } from "react-csv";
import { useAuth } from '../../AuthContext.js';
import ReceiptIcon from '@mui/icons-material/Receipt';
import CreditForm from '../components/CreditForm.js';
import CreditDebitPreview from '../components/CreditDebitPreview.js';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const CreditnotePage = () => {

  const [isNewCreditFormOpen, setIsNewCreditFormOpen] = useState(false);

  const openNewCreditForm = () => {
    setIsNewCreditFormOpen(true);
  };

  const closeNewCreditForm = () => {
    setIsNewCreditFormOpen(false);
  };
  let [selectedRow, setSelectedRow] = useState(null);
  const [selectedRowDataPreview, setSelectedRowDataPreview] = useState();
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const [data, setData] = useState([]);
  const { userRole } = useAuth()
  const [employee, setEmployee] = useState(true);

  useEffect(() => {
    if (userRole === "manager") {
      setEmployee(false)
    } else {
      setEmployee(true)
    };
  }, [userRole])


  const delete_Credit = async (id) => {
    try {
      const response = await axios.delete(`${process.env.REACT_APP_BASE_URL}/credits/del_credit`, {
        data: {
          id: id
        }
      });
      if (response.data.success) {
        toast.success(`Credit Note with id: ${id} deleted successfully.`);
      } else {
        toast.error("Error deleting Credit Note");
      }
    } catch (error) {
      toast.error("Error deleting Credit Note");
    }
  };


  useEffect(() => {
    const fetch_Credits = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/credits/all_credits`);
        const responseData = await response.json();
        if (responseData) {
          setData(responseData.credit);
        }
      } catch (error) {
        // Handle errors here
        console.error("Error fetching data:", error);
      }
    }
    fetch_Credits();
  }, [isNewCreditFormOpen])


  const columns = useMemo(
    () => [
      {
        accessorKey: 'id', //access nested data with dot notation
        header: 'creditId',
        size: 100,
      },
      {
        accessorKey: 'clientid', //access nested data with dot notation
        header: 'Client Id',
        size: 100,
      },
      {
        accessorKey: 'clientname', //access nested data with dot notation
        header: 'Client Name',
        size: 100,
      },
      {
        accessorKey: 'clientphone',
        header: 'Client Phone',
        size: 100,
      },
      {
        accessorKey: 'clientaddress', //normal accessorKey
        header: 'Client Address',
        size: 200,
      },
      {
        accessorKey: 'amount', //normal accessorKey
        header: 'Amount',
        size: 200,
      },
      {
        accessorKey: 'date',
        header: 'Date',
        size: 100,
      },
      {
        accessorKey: 'description',
        header: 'Description',
        size: 100,
      },
      {
        accessorKey: 'clientlpo',
        header: 'Client LPO',
        size: 100,
      }
    ],
    [],
  );


  return (
    <>
      <StickyTitle title="Credit Note" button_action={openNewCreditForm} button="New credit note" />
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      <div className=' px-4 lg:px-5 py-4 lg:py-10 flex flex-col gap-0 overflow-x-auto'>
        <div className="table-filters flex flex-row items-center justify-between mt-3 mb-3">
          <div className='text-2xl ml-5 font-bold font-poppins flex items-center'>All Credit Notes<button onClick={openNewCreditForm} className='px-3 py-0 text-3xl rounded bg-[#37a703] text-white font-bold font-poppins ml-2 sm:block hidden'>+</button></div>
          <CreditForm isOpen={isNewCreditFormOpen} onClose={closeNewCreditForm} />
        </div>

        {data ? (<div className="w-full">
          <MaterialReactTable
            enableRowActions
            enableRowSelection
            columns={columns}
            data={data}
            renderRowActions={({ row }) => (
              <Box>
                <IconButton onClick={() => {
                  let rowData = row.original;
                  setSelectedRowDataPreview(rowData)
                  setIsPopupOpen(true);
                }}>
                  <ReceiptIcon />
                </IconButton>
              </Box>
            )}
            renderTopToolbarCustomActions={({ table }) => {
              const handleDelete = () => {
                const selectedRows = table.getSelectedRowModel().flatRows;

                if (selectedRows.length === 1) {
                  selectedRow = selectedRows[0];
                  const selectedRowId = selectedRow.original.id;
                  setSelectedRow(selectedRow);
                  alert('Deleting creditwith ID: ' + selectedRowId);
                  delete_Credit(selectedRowId)

                } else {
                  alert('Please select a single row to delete.');
                }
              };
              // const handleEdit = () => {
              //   const selectedRows = table.getSelectedRowModel().flatRows;

              //   if (selectedRows.length === 1) {
              //     const selectedRow = selectedRows[0];
              //     selectedRowData = selectedRow.original;
              //     setSelectedRowData(selectedRowData);
              //     setisNewCreditFormOpen(true); // Open the form
              //   } else {
              //     alert('Please select a single row to Edit.');
              //   }
              // };


              return (
                <div style={{ display: 'flex', gap: '0.5rem' }}>
                  <Button
                    color="error"
                    disabled={!table.getIsSomeRowsSelected()}
                    onClick={handleDelete}
                    variant="contained"
                    sx={employee ? { display: 'none' } : {}}

                  >
                    Delete
                  </Button>
                  {/* <Button
                    color="success"
                    disabled={!table.getIsSomeRowsSelected()}
                    onClick={handleEdit}
                    variant="contained"
                    sx={employee ? { display: 'none' } : {}}

                  >
                    Edit
                  </Button> */}
                  <Button
                    color="success"
                    variant="contained"
                  >
                    <CSVLink data={data}>Export to CSV</CSVLink>
                  </Button>
                </div>
              );
            }}
          />
        </div>) : (null)}
      </div>

      <div>
        {isPopupOpen && (
          <div style={{
            display: isPopupOpen ? 'block' : 'none',
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            padding: '20px',
            boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)',
            zIndex: '999',
            height: '90vh',
            overflowY: 'auto',
            width: '800px'
          }}>

            <button
              className="absolute top-2 right-2 text-gray-600 hover:text-gray-800 bg-transparent border-5 border-black"
              onClick={() => setIsPopupOpen(false)}
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>

            <CreditDebitPreview
              debitNote={false}
              creditNote={true}
              clientaddress={selectedRowDataPreview.clientaddress}
              clientname={selectedRowDataPreview.clientname}
              description={selectedRowDataPreview.description}
              debitAmount={selectedRowDataPreview.amount}
              creditAmount={selectedRowDataPreview.amount}
              date={selectedRowDataPreview.date}
            />

          </div>
        )}
      </div>

    </>
  );
};

export default CreditnotePage;
